import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { FormsModule } from '@angular/forms';
import { HttpClientJsonpModule, HttpClientModule } from '@angular/common/http';
import { RouterModule } from "@angular/router";
import { ThemeConstantService } from './services/theme-constant.service';
import { SearchPipe } from './pipes/search.pipe';
import { MatDialogModule } from '@angular/material/dialog';
import { NgxPaginationModule } from 'ngx-pagination';
import { DateAgoPipe } from './pipes/date-ago.pipe';
import { RemoveDomainPrefixSuffixPipe } from './pipes/remove-domain-prefix-suffix.pipe';
import { WarcViewerComponent } from './Evidences/warc-viewer/warc-viewer.component';
import { ScreenshotComponent } from './Evidences/screenshot/screenshot.component';
import { NetworkLogViewerComponent } from './Evidences/network-log-viewer/network-log-viewer.component';
import { VideoPlayerComponent } from './Evidences/video-player/video-player.component';
import { SazViewerComponent } from './Evidences/saz-viewer/saz-viewer.component';
import { ShortNumberPipe } from './pipes/short-number.pipe';


@NgModule({
    exports: [
        CommonModule,
        FormsModule,
        HttpClientModule,
        HttpClientJsonpModule,
        SearchPipe,
        DateAgoPipe,
        RemoveDomainPrefixSuffixPipe
       
    ],
    imports: [
        RouterModule,
        CommonModule,
        MatDialogModule,
        NgxPaginationModule
    ],
    declarations: [
        SearchPipe, DateAgoPipe, 
        RemoveDomainPrefixSuffixPipe,
        WarcViewerComponent,
        ScreenshotComponent,
        NetworkLogViewerComponent,
        VideoPlayerComponent,
        SazViewerComponent
    ],
    providers: [
        ThemeConstantService
    ],
    schemas:[CUSTOM_ELEMENTS_SCHEMA]
})

export class SharedModule { }
